<template>
    <div class="dd-card">
        <iframe
            :src="`${metabaseUrl}/${type}/${uuid}?company_id=${companyUuid}`"
            frameborder="0"
            width="100%"
            height="500"
            allowtransparency
        ></iframe>
    </div>
</template>

<script>
export default {
    name: 'ChartPie',
    props: {
        uuid: String,
        type: String
    },
    data() {
        return {
            companyUuid: '',
            metabaseUrl: ''
        }
    },
    mounted() {
        this.companyUuid = JSON.parse(localStorage.getItem('company')).uuid
        this.metabaseUrl = process.env.VUE_APP_METABASE_PUBLIC_URL
    },

    methods: {}
}
</script>

<style scoped>
.dd-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    padding: 8px;
}

.dd-card iframe {
    border-radius: 12px;
}
</style>
